export default "__VITE_ASSET__c354841d__"